import { api } from '@/api';
import { API_URL } from '@/dtos';
import {
  OcrWarningFields,
  OcrWarnings,
  OcrWarningType,
  ParsedOcrWarnings,
  TransactionParsedFileByOcr,
  TransactionParsedFileByOcrPayload,
} from '@/modules/transaction/components/ReimburseMe/FileScan/fileScan.types';

export const formatWarnings = (parsedWarnings?: ParsedOcrWarnings[]) => {
  const ocrWarnings: OcrWarnings = {
    [OcrWarningType.MISSING]: [],
    [OcrWarningType.OUT_OF_COVERAGE_DATE]: [],
    [OcrWarningType.RETAIL_OUT_OF_COVERAGE_DATE]: [],
    [OcrWarningType.DUPLICATE_RECEIPT]: [],
  };

  if (!parsedWarnings || parsedWarnings.length === 0) {
    return ocrWarnings;
  }

  parsedWarnings.forEach((warning) => {
    const warningFields = warning?.fields?.map((fieldName) => OcrWarningFields[fieldName]);
    if (warningFields && warning?.type) {
      ocrWarnings[warning.type]?.push(...warningFields);
    }
  });

  return ocrWarnings;
};

const formatData = (data: TransactionParsedFileByOcrPayload): TransactionParsedFileByOcr => ({
  aiApproved: data?.ai_approved,
  warningsFields: formatWarnings(data?.warnings),
});

const useGetScannedDocumentByHashIdQuery = () => {
  const getScannedDocument = async (fileId: string, hashId: string) => {
    try {
      // TODO EL-33479:  Server returns IOcrClaimDto (from generated OpenAPI DTOs), but formatData
      // consumes the local TransactionParsedFileByOcrPayload shape. Reconcile
      // formatData/types with IOcrClaimDto and drop this explicit generic once aligned.
      const { data } = await api.get<TransactionParsedFileByOcrPayload>(API_URL.DOCUMENTS_FILES_BY_LINK_OPENAI_OCR_MATCHING_BY_FILE_ID(fileId), {
        params: {
          hash_id: hashId,
        },
      });

      const formattedData = formatData(data);
      return formattedData;
    } catch (error) {
      return null;
    }
  };

  return { getScannedDocument };
};

export default useGetScannedDocumentByHashIdQuery;
